import { getCurrentScriptOrigin } from './utils/currentScript';

// Resolve where the SDK sends metrics. Priority:
//  1. build-time configured host (LAGLOG_MONITORING_HOST),
//  2. the origin the SDK script was loaded from (the current site's <script> src),
// Reading the script origin goes through getCurrentScriptOrigin so a Termly-style
// relative currentScript.src can't crash init — see docs/KNOWN_ISSUES.md.
export const getMonitoringHost = (configuredHost?: string) =>
    configuredHost || getCurrentScriptOrigin();
